import { useState } from 'react';
import { useQuery } from 'react-query';

// React Query v2 accepts a numeric interval, not an interval callback.
// Once denied/failed, only an explicit refresh may start this query again.
export const usePortalQuery = (key, request, { enabled, interval }) => {
  const [failedKey, setFailedKey] = useState(null);
  const scope = JSON.stringify(key);
  return useQuery(key, request, {
    enabled,
    retry: false,
    cacheTime: 300000,
    staleTime: 0,
    keepPreviousData: false,
    refetchInterval: enabled && failedKey !== scope ? interval : false,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    onError: () => setFailedKey(scope),
    onSuccess: () => setFailedKey(null),
  });
};
